import { createSelector } from 'reselect'
import { formatLibraryType } from 'helpers/libraryTypeFormatter'
import formatLessonTypeFromView from 'helpers/lessonTypeFormatter'
import libraryTypes from 'helpers/enums/libraryTypes'
import viewTypes from 'helpers/enums/viewTypes'

const myLibrarySelector = state => state.myLibrary
const ltiSelector = state => state.lti
const uiSelector = state => state.ui

const myLibraryDataSelector = createSelector(
	[myLibrarySelector, ltiSelector, uiSelector],
	(myLibrary, lti, ui) => {
		const libraryType = formatLibraryType(lti)
		const lessonType = formatLessonTypeFromView(ui.currentView)

		const showAllLessons = [
			viewTypes.INTERACTIVE_VIDEO_CREATE,
			viewTypes.VIDEO_CREATE,
			viewTypes.VIDEO_STANDALONE_CREATE,
		].includes(ui.currentView)

		const searchData = {
			page: myLibrary.current.search.page,
			fromLTI: libraryType !== libraryTypes.REGULAR,
			more: myLibrary.current.search.more,
			input_value: myLibrary.input_value,
			order_field: myLibrary.order_field,
			lessonType,
		}
		return {
			searchData,
			folderUID: myLibrary.folderUID,
			libraryType,
			showAllLessons,
		}
	}
)

export default myLibraryDataSelector
